module.exports = __webpack_public_path__ + "img/040-file-picture.adff2f0c.svg";